import { FC, useState } from 'react';

// * Components
import TabTitle from './TabTitle';

// * Props
import { TabsProps } from './Tabs.interface';

// * Styles
import styles from "./Tabs.module.css";
import cn from 'classnames';

const Tabs: FC<TabsProps> = ({ items, onTabChange, containerClassName, tabsContainerClassName, titleClassName, activeClassName }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const handleTabClick = (index: number, title: string) => {
    if (onTabChange) {
      const shouldContinue = onTabChange(title, index);
      if (!shouldContinue) {
        return;
      }
    }

    setSelectedTabIndex(index);
  };

  return (
    <div className={cn(styles.tabs, containerClassName)}>

      <ul className={cn(styles.tabs__titles, tabsContainerClassName)}>
        { items.map((item, index) => (
            <TabTitle
              key={item.title}
              title={item.title}
              tabIndex={index}
              isActive={index === selectedTabIndex}
              setSelectedTab={() => handleTabClick(index, item.title)}
              titleClassName={titleClassName}
              activeClassName={activeClassName}
            />
          ))
        }
      </ul>

      {items[selectedTabIndex].component}
    </div>
  );
};

export default Tabs;